// libs
import { styled } from '@nykaa/ui-components';

//components
import SearchIcon from '@nykaa/ui-components/Icons/search';
import Close from '@nykaa/ui-components/Icons/circle-x-filled';

//constants
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const SearchContainer = styled.div`
  background: ${({ theme }) => theme.colors.surface20};
  border-radius: ${({ theme }) => theme.borders.radius20};
  padding: ${({ theme }) => `${theme.spacing.spacing0} ${theme.spacing.spacing50}`};
  border-bottom: 2px solid transparent;
  &:focus-within {
    border-bottom: 2px solid ${({ theme }) => theme.colors.secondary};
  }
  transition: border-bottom 0.2s ease;
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputSearchIcon = styled(SearchIcon)`
  vertical-align: middle;
`;

export const CloseIcon = styled(Close)`
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  vertical-align: middle;
  cursor: pointer;
  position: absolute;
  right: ${BASE_GUTTER_SPACE}px;
`;

export const InputField = styled.input`
  ${({ theme }) => theme.typography.bodyMedium};
  border-radius: ${({ theme }) => theme.borders.radius35};
  background: ${({ theme }) => theme.colors.surface20};
  padding: ${({ theme }) => theme.spacing.spacing40};
  padding-left: ${({ theme }) => theme.spacing.spacing40};
  border: none;
  outline: none;
`;
